export default __webpack_public_path__ + "static/media/navbar-incoming-messages-dark.1a7d13b0.svg";